import { validateEmail } from './../../../scripts/helpers/utils'

export default class NewsletterSignup {
  constructor(component) {
    this.dom = {
      $component: component,
      $errorMessage: component.querySelector('.js-signUpError'),
      $form: component.querySelector('#js-NewsletterSignupForm'),
      $email: component.querySelector('.js-signUpEmailInput')
    }
    this.state = {
      errorClass: 'error'
    }
    this.checkEmailHandler = this.checkEmail.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    this.attachKlaviyoForm()
    dom.$form.addEventListener('submit', this.checkEmailHandler)
  }

  attachKlaviyoForm() {
    KlaviyoSubscribe.attachToForms('#js-NewsletterSignupForm', {
      success: this.submitSuccess.bind(this)
    })
  }

  submitSuccess(test) {
    const { dom, state } = this
    dom.$component.classList.remove(state.errorClass)

    const event = new Event('newsletterSubmitSuccess')
    document.dispatchEvent(event)
  }

  checkEmail(e) {
    const { dom, state } = this
    const email = dom.$email.value

    if (!validateEmail(email)) {
      e.preventDefault()
      dom.$component.classList.add(state.errorClass)
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.NewsletterSignup = this
  }
}
